import { useLoading } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getEvent } from '../../../services/gptService';
import { eventDetailState } from '../../../storage/gptStates';

export function useGptEventDetail() {
  const { eventId } = useParams();
  const [event, setEvent] = useRecoilState(eventDetailState);
  const [update, setUpdate] = useState(0);
  const { startLoading, stopLoading, loading } = useLoading();

  useEffect(() => {
    if (!eventId) return;

    const loadEvent = async () => {
      startLoading();
      const { event: eventDetail, error } = await getEvent(eventId);
      if (eventDetail && !error) {
        setEvent(eventDetail);
      } else {
        setEvent(undefined);
      }
      stopLoading();
    };

    loadEvent();
  }, [eventId, update]);

  const reload = () => {
    setUpdate((prev) => prev + 1);
  };

  return {
    event,
    loadingEvent: loading,
    reloadEvent: reload,
  };
}
